import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Sofía', 'Lucas', 'Valentina', 'Mateo', 'Camila', 'Benjamín', 'Martina', 'Joaquín', 'Lucía', 'Bautista', 'Catalina', 'Felipe', 'Elena'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Corrientes', 'Bahía Blanca', 'San Isidro', 'Vicente López', 'Neuquén', 'Posadas'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
      // Schedule next notification (random between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(triggerNotification, nextDelay);
    }, 4000);
  };
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-15">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-teal-500 p-4 max-w-sm flex items-start gap-3" data-id="element-16">
        <div className="flex-shrink-0 text-teal-500 mt-0.5" data-id="element-17">
          <CheckCircle2 className="h-6 w-6" data-id="element-18" />
        </div>
        <div className="flex-1 mr-2" data-id="element-19">
          <p className="text-sm font-medium text-gray-900" data-id="element-20">
            ¡Nueva compra verificada!
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-21">
            <span className="font-semibold" data-id="element-22">{data.name}</span> de {data.city}{' '}
            acaba de adquirir el{' '}
            <span className="text-teal-700 font-medium" data-id="element-23">Kit Terapéutico</span>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-24">Hace unos instantes</p>
        </div>
        <button onClick={() => setVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-25">
          <X className="h-4 w-4" data-id="element-26" />
        </button>
      </div>
    </div>;
}